const React = require("react");
const PropTypes = require("prop-types");
require("./InfoCards.scss");

const InfoGrid = ({ children, columns = 3, className = "" }) => {
  const style = { ["--info-columns-desktop"]: columns };
  const classes = ["info-grid", className].filter(Boolean).join(" ");
  return (
    <div className={classes} style={style}>
      {children}
    </div>
  );
};

const InfoCard = ({ title, icon, children, className = "", footer }) => {
  const classes = ["info-card", className].filter(Boolean).join(" ");
  return (
    <section className={classes}>
      <div className="info-card__header">
        {icon && (
          <span className="info-card__icon" aria-hidden="true">
            {icon}
          </span>
        )}
        <h3 className="info-card__title">{title}</h3>
      </div>
      <div className="info-card__body">{children}</div>
      {footer && <div className="info-card__footer">{footer}</div>}
    </section>
  );
};

InfoGrid.propTypes = {
  children: PropTypes.node,
  columns: PropTypes.number,
  className: PropTypes.string,
};

InfoCard.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  footer: PropTypes.node,
};

module.exports = { InfoGrid, InfoCard };
